var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.1875C20.932 17.1875 21.6875 17.943 21.6875 18.875V30.125C21.6875 31.057 20.932 31.8125 20 31.8125C19.068 31.8125 18.3125 31.057 18.3125 30.125V18.875C18.3125 17.943 19.068 17.1875 20 17.1875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.25C21.2426 13.25 22.25 12.2426 22.25 11C22.25 9.75736 21.2426 8.75 20 8.75C18.7574 8.75 17.75 9.75736 17.75 11C17.75 12.2426 18.7574 13.25 20 13.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.3125 20C0.3125 9.12689 9.12689 0.3125 20 0.3125C30.8731 0.3125 39.6875 9.12689 39.6875 20C39.6875 30.8731 30.8731 39.6875 20 39.6875C9.12689 39.6875 0.3125 30.8731 0.3125 20ZM20 3.6875C10.9909 3.6875 3.6875 10.9909 3.6875 20C3.6875 29.0091 10.9909 36.3125 20 36.3125C29.0091 36.3125 36.3125 29.0091 36.3125 20C36.3125 10.9909 29.0091 3.6875 20 3.6875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInformation);
export default __webpack_public_path__ + "static/media/ico-information.aee5d4124292987ed23ba5170944ffe6.svg";
export { ForwardRef as ReactComponent };